module.exports = __webpack_public_path__ + "fba617568c59c3d2e0bdbbf264b48273.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1024.webp.png
// module id = 503
// module chunks = 0